var _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcInfoBlue(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1382_12925",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 18,
    height: 18
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.75 11C2.75 6.425 6.425 2.75 11 2.75C15.575 2.75 19.25 6.425 19.25 11C19.25 15.575 15.575 19.25 11 19.25C6.425 19.25 2.75 15.575 2.75 11ZM4.2501 11C4.2501 14.75 7.2501 17.75 11.0001 17.75C14.7501 17.75 17.7501 14.75 17.7501 11C17.7501 7.25 14.7501 4.25 11.0001 4.25C7.2501 4.25 4.2501 7.25 4.2501 11ZM11.75 11V14C11.75 14.45 11.45 14.75 11 14.75C10.55 14.75 10.25 14.45 10.25 14V11C10.25 10.55 10.55 10.25 11 10.25C11.45 10.25 11.75 10.55 11.75 11ZM11.75 8C11.75 7.775 11.675 7.625 11.525 7.475C11.375 7.325 11.075 7.25 10.85 7.25C10.8069 7.29313 10.7885 7.31146 10.7665 7.31924C10.7502 7.325 10.7319 7.325 10.7 7.325C10.6625 7.325 10.6438 7.34375 10.625 7.3625C10.6062 7.38125 10.5875 7.4 10.55 7.4L10.475 7.475C10.325 7.625 10.25 7.775 10.25 8C10.25 8.225 10.325 8.375 10.475 8.525C10.475 8.525 10.475 8.6 10.55 8.6C10.5875 8.6 10.6062 8.61875 10.625 8.6375C10.6438 8.65625 10.6625 8.675 10.7 8.675C10.7431 8.71813 10.7615 8.73646 10.7835 8.74424C10.7998 8.75 10.8181 8.75 10.85 8.75H11C11.225 8.75 11.375 8.675 11.525 8.525C11.675 8.375 11.75 8.225 11.75 8Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1382_12925)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "#21B5CD"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcInfoBlue);
export default __webpack_public_path__ + "static/media/ic_info_blue.008a5eee486798314d42c97af4f811cd.svg";
export { ForwardRef as ReactComponent };